<template>
	<div class="tab-pane fade" id="tab-colaboratorgroups" role="tabpanel" aria-labelledby="colaboratorgroups-tab">

		<div class="row section-top">
			<div class="col-md-12 pad0">
				<p class="section-lead">Lista de todos Grupos de Colaboradores cadastrados</p>
				<a href="#" @click="resetForm()" class="btn btn-outline-success float-right" data-toggle="modal" data-target="#modalColaboratorGroups"><i class="fas fa-plus"></i>&nbsp;Novo</a>
			</div>
		</div>

		<div class="row">
			<div class="col">

				<!-- table -->
				<div class="card p-4">
					<vue-good-table v-if="colaboratorgroupsItems.length"
						:columns="tableColumns"
						:rows="colaboratorgroupsItems"
						:pagination-options="tablePagination"
						:search-options="{
							enabled: true,
							placeholder: 'Buscar..'
						}"
						styleClass="vgt-table"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'actions'">
								<div>
									<button class="btn btn-sm btn-outline-secondary" v-if="userCan.edit" @click="editData(props.row)" title="Editar"><i class="far fa-edit"></i></button>
									<button class="btn btn-sm btn-outline-danger" v-if="userCan.delete" @click="deleteData(props.row.id, props.row.originalIndex)" title="Deletar"><i class="far fa-trash-alt"></i></button>
								</div>
							</span>
							<span v-else>
								{{ props.formattedRow[props.column.field] }}
							</span>
						</template>
						<template slot="pagination-bottom">
							<table-pagination-component :_options="tablePaginationOptions" @paginate="pagination"></table-pagination-component>
						</template>
					</vue-good-table>
					<div v-else class="text-center p-3 text-muted">
						<h5>Nenhum grupo de colaborador cadastrado!</h5>
					</div>
				</div>

				<div class="text-center p-4 text-muted" v-if="loading">
					<h5>Carregando...</h5>
					<p>Aguarde até que os dados sejam carregados...</p>
				</div>

			</div>

			<!-- modal -->
			<div class="modal fade" id="modalColaboratorGroups" tabindex="-1" aria-labelledby="modalColaboratorGroupsLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="modalColaboratorGroupsLabel">{{colaboratorgroupsTitle}}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<form v-on:submit.prevent="saveData">

								<div class="row">

							<!-- name -->
							<div class="col-md-12">
								<div class="form-group">
									<label class="form-control-label" for="input-name">Nome</label>
									<input type="text" id="input-name" v-bind:class="{'is-invalid': errors.name}"   class="form-control" placeholder="Nome" v-model="colaboratorgroup.name" required="true" >
									<div class="invalid-feedback d-block" v-if="errors.name">
										<p>{{ errors.name[0] }}</p>
									</div>
								</div>
							</div>
							
								</div>

								<div class="text-right">
									<button type="submit" class="btn btn-success">SALVAR</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<!-- end modal -->

		<vue-loading color="#212121" :active.sync="loading" :can-cancel="false" :is-full-page="fullPage"></vue-loading>
		</div>
	</div>
</template>

<script>
	import ApiService from '../../../apiservice.js';
	import configData from "../../../config.js";
	export default {
		mixins: [ApiService, configData],
		props: ['companies','permissions'],
		data() {
			return {
				colaboratorgroupsTitle: "Novo Grupo de Colaboradores",
				colaboratorgroup: {
					name: '',
				},
				companyID: '',
				isEditColaboratorGroups: false,
				colaboratorgroupsID: "",
				colaboratorgroupsItems: [],
				fullPage: true,
				errors: [],
				loading: false,
				tableColumns: [
					{
						label: 'ID',
						field: 'id',
					},{
						label: 'Nome',
						field: 'name',
					},{
						label: 'Data e Hora',
						field: 'created_at',
						type: 'date',
						dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
						dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
					},{
						label: 'Ações',
						field: 'actions',
						sortable: false,
						width: '100px'
					}
				],
				// tablePaginationOptions: {
				// 	currentPage: 1,
				// 	currentPerPage: configData.tablePagination.perPage,
				// 	total: 0,
				// 	from: 0,
				// 	to: 0
				// },
				// paginationOptions: {
				// 	enabled: configData.tablePagination.enabled,
				// 	mode: configData.tablePagination.mode,
				// 	perPage: configData.tablePagination.perPage,
				// 	perPageDropdown: [10, 50, 100, 500],
				// 	dropdownAllowAll: configData.tablePagination.dropdownAllowAll,
				// 	nextLabel: configData.tablePagination.nextLabel,
				// 	prevLabel: configData.tablePagination.prevLabel,
				// 	rowsPerPageLabel: configData.tablePagination.rowsPerPageLabel,
				// 	ofLabel: configData.tablePagination.ofLabel,
				// 	pageLabel: configData.tablePagination.pageLabel,
				// 	allLabel: configData.tablePagination.allLabel,
				// },
				tablePagination: configData.tablePagination,
				tablePaginationOptions: {
					currentPage: 1,
					currentPerPage: 10,
					from: 0,
					to: 0,
					total: null
				},
				userCan: ''
			}
		},
		mounted() {
			this.companyID = (JSON.parse(this.companies)).id;
			this.userCan = JSON.parse(this.permissions);
			if(this.userCan.list){
				this.loadItems();
			}
		},
		methods: {
			pagination(page){
				this.tablePaginationOptions = {
					currentPage: page.options.currentPage,
					currentPerPage: page.options.currentPerPage,
					from: page.options.from,
					to: page.options.to,
					total: page.options.total
				};
				this.loadItems();
			},
			loadItems() {
				let _this = this;
				var params = {
					page: _this.tablePaginationOptions.currentPage,
					perPage: _this.tablePaginationOptions.currentPerPage,
				};
				_this.colaboratorgroupsItems = [];
				_this.loading = true;
				axios.post("/admin/colaboratorgroups/"+this.companyID+"/filter", {}, {params: params}).then((res) => {
					const { data, total, from, to } = res.data.data;
					_this.tablePaginationOptions.total = parseInt(total);
					_this.tablePaginationOptions.from = parseInt(from);
					_this.tablePaginationOptions.to = parseInt(to);
					_this.colaboratorgroupsItems = [...data];
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
			saveData() {
				let _this = this;
				_this.errors = [];
				_this.loading = true;

				if (_this.isEditColaboratorGroups == true){

					let dataInfo = {
						"name" : _this.colaboratorgroup.name,
						"_method": "PATCH"
					};
					axios.post("/admin/colaboratorgroups/"+_this.colaboratorgroupsID, dataInfo).then((res) => {

						_this.loading = false;
						_this.resetForm();

						$('#modalColaboratorGroups').modal('hide');

						//call function in ApiService to validate success
						_this._api_validateSuccess(res,false);

					}).catch((err) => {

						_this.loading = false;

						if (err.response.data.errors){
							//set errors
							_this.errors = err.response.data.errors;
						}

						//call function in ApiService to validate error
						_this._api_validateError(err);

					});

				} else {

					let dataInfo = {
						"name" : _this.colaboratorgroup.name,
						"company_id": _this.companyID,
						"last": ""
					};
					axios.post("/admin/colaboratorgroups", dataInfo).then((res) => {

						_this.loading = false;
						_this.resetForm();

						_this.colaboratorgroupsItems.push(res.data.data);
						$('#modalColaboratorGroups').modal('hide');

						//call function in ApiService to validate success
						_this._api_validateSuccess(res,false);

					}).catch((err) => {

						_this.loading = false;

						if (err.response.data.errors){
							//set errors
							_this.errors = err.response.data.errors;
						}

						//call function in ApiService to validate error
						_this._api_validateError(err);

					});
				}
			},
			deleteData(ID, index) {
				let _this = this;

				//show alert confirmation
				_this.$swal({
					title: "Excluir Grupo de Colaboradores",
					text: "Tem certeza que deseja excluir esse Grupo de Colaboradores?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonText: "Excluir",
					cancelButtonText: "Cancelar"
				}).then((alertConfirm) => {

					//validate isConfirmed
					if (alertConfirm.isConfirmed) {

						//remove
						axios.delete("/admin/colaboratorgroups/"+ID).then((res) => {

							_this.colaboratorgroupsItems.splice(index, 1);

							//call function in ApiService to validate success
							_this._api_validateSuccess(res,false);

						}).catch(err => {

							_this.loading = false;

							//call function in ApiService to validate error
							_this._api_validateError(err);

						});

					}//end validate isConfirmed

				});
				//end alert confirmation

			},
			editData(item){

				this.colaboratorgroup = item;
				this.isEditColaboratorGroups = true;
				this.colaboratorgroupsID = item.id;
				this.colaboratorgroupsTitle = "Editar Grupo de Colaboradores";

				$("#modalColaboratorGroups").modal('show');

			},
			resetForm(){

				this.colaboratorgroup = {
					name: '',
					companyID: ''
				};
				this.errors = [];

			}
		}
	}
</script>
